import Vue from 'vue';

export default function() {

    // Core
    Vue.directive('background-image', require('js-core/js/directives/backgroundImage').default);
    Vue.directive('click-outside', require('js-core/js/directives/clickOutside').default);
    Vue.directive('spinner', require('js-core/js/directives/spinner').default);

    // UI
    Vue.directive('tooltip', require('js-ui/js/directives/tooltip').default);
}
